import React from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router-dom';
import Text from 'shared/components/text';
import Button from 'src/components/button';
import 'stylesheets/components/account-settings-form-section.scss';
import 'stylesheets/components/account-settings-form-footer.scss';
import Title from 'src/components/AccountSettings/Title';

const AccountConversion = ({history}) => {
  const navigateTo = (dest) => () => history.push(dest);

  return (
    <div className="account-settings-form">
      <Title>Convert to Community College Account</Title>
      <section className="account-settings-form-section borderless">
        <div className="form-container">
          <Text weight={5} showOverflow>
            Students who can attend a US community college after high school can use Raise Me to
            help them transfer by earning scholarship from 4-year colleges.
          </Text>
          <Text weight={5} showOverflow className="small-sub-text">
            *Your high school info is not valid for transfer earnings, but we keep a record for you.
          </Text>
          <div className="account-settings-form-footer">
            <div className="account-settings-conversion-form-footer-save">
              <Button
                color="primary"
                type="submit"
                margin={false}
                horizontalMargin
                buttonName="form-footer save"
                onClick={navigateTo(
                  '/account-settings/convert/next-steps/community-college?step=1'
                )}
                outline
                size="medium"
              >
                Get Reminder
              </Button>
              <Button
                color="primary"
                type="submit"
                margin={false}
                buttonName="form-footer save"
                onClick={navigateTo('/account-conversion')}
                size="medium"
              >
                Convert
              </Button>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

AccountConversion.propTypes = {
  history: PropTypes.object.isRequired,
};

export default withRouter(AccountConversion);
